module.exports = __webpack_public_path__ + "media/cyclesTile@lg-3fbd29cc6974814c15c755697ec0811f.jpg";